import { keyframes } from './system';
export const slideUpAndFadeKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translateY(2px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' }
});
export const slideRightAndFadeKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translateX(-2px)' },
    '100%': { opacity: 1, transform: 'translateX(0)' }
});
export const slideDownAndFadeKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translateY(-2px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' }
});
export const slideLeftAndFadeKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translateX(2px)' },
    '100%': { opacity: 1, transform: 'translateX(0)' }
});
export const overlayShowKeyframes = keyframes({
    '0%': { opacity: 0 },
    '100%': { opacity: 1 }
});
export const contentShowKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translate(-50%, -48%) scale(.96)' },
    '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' }
});
export const contentShowMobileKeyframes = keyframes({
    '0%': { opacity: 0, transform: 'translate(-50%, -2%) scale(.96)' },
    '100%': { opacity: 1, transform: 'translate(-50%, 0) scale(1)' }
});
export const pulseKeyframes = keyframes({
    '0%': { transform: 'scale(0)' },
    '50%': { transform: 'scale(1)' },
    '100%': { transform: 'scale(0)' }
});
export const spinKeyframes = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
});
